<template>
	<div>
		<v-container>
			<v-row>
				<v-col cols="12">
					<v-breadcrumbs :items="breadcrumbs">
						<template #divider>
							<v-icon>mdi-chevron-left</v-icon>
						</template>
					</v-breadcrumbs>
				</v-col>
			</v-row>

			<v-card>
				<v-card-text>
					<v-row>
						<v-col cols="12" md="6" class="pa-2">
							<v-select
								v-model="newCommunication.type"
								outlined
								hide-details="auto"
								label="نوع الإتصال"
								:items="contactTypes"
								item-value="communicationTypeID"
								item-text="name"
							></v-select>
						</v-col>
						<v-col cols="12" md="6" class="pa-2">
							<v-text-field
								v-model="newCommunication.value"
								outlined
								hide-details="auto"
								label="المعرف"
								class="ltr-content"
								:rules="[rules.maxLength250]"
								counter="250"
							></v-text-field>
						</v-col>
						<!-- <v-col v-if="newCommunication.type == 'telephone'" cols="12" class="pa-2">
							<v-text-field
								v-model="newCommunication.extension"
								outlined
								hide-details="auto"
								label="التحويلة"
								class="ltr-content"
								:rules="[rules.maxLength250]"
								counter="250"
							></v-text-field>
						</v-col> -->
						<v-col cols="12" class="pa-2">
							<v-textarea
								v-model="newCommunication.note"
								:rows="3"
								outlined
								hide-details="auto"
								label="ملاحظة (اختياري)"
								:rules="[rules.maxLength250]"
								counter="250"
							></v-textarea>
						</v-col>

						<v-col cols="12" class="pa-2 text-center">
							<v-btn
								color="success"
								:loading="loading"
								:disabled="!newCommunication.type || !newCommunication.value"
								@click="addContact"
							>
								إضافة
								<v-icon right>mdi-plus</v-icon>
							</v-btn>
						</v-col>

						<v-col cols="12" class="pa-2">
							<v-data-table hide-default-footer :headers="headers" :items="info" :items-per-page="-1">
								<template #[`item.value`]="{ item }">
									<div v-if="item.isEdit" dir="ltr" class="text-end">
										<v-text-field v-model="item.value" :disabled="item.isLoading"></v-text-field>
									</div>
									<div v-else dir="ltr" class="text-end">{{ item.value }}</div>
								</template>

								<template #[`item.note`]="{ item }">
									<div v-if="item.isEdit">
										<v-text-field v-model="item.note" :disabled="item.isLoading"></v-text-field>
									</div>
									<div v-else>{{ item.note }}</div>
								</template>

								<template #[`item.actions`]="{ item }">
									<v-tooltip bottom>
										<template #activator=" {on} ">
											<v-btn icon medium :disabled="item.isLoading" v-on="on" @click="deleteCommunication(item)">
												<v-icon color="error">mdi-comment-remove</v-icon>
											</v-btn>
										</template>
										<span>حذف</span>
									</v-tooltip>

									<v-tooltip v-if="item.isEdit == false" bottom>
										<template #activator=" {on} ">
											<v-btn icon medium :disabled="item.isLoading" v-on="on" @click="enableEditCommunication(item)">
												<v-icon color="primary">mdi-comment-edit</v-icon>
											</v-btn>
										</template>
										<span>تحرير</span>
									</v-tooltip>

									<v-tooltip v-else bottom>
										<template #activator=" {on} ">
											<v-btn icon medium :disabled="item.isLoading" v-on="on" @click="enableEditCommunication(item)">
												<v-icon color="success">mdi-comment-check</v-icon>
											</v-btn>
										</template>
										<span>حفظ</span>
									</v-tooltip>
								</template>
							</v-data-table>
						</v-col>
					</v-row>
				</v-card-text>
			</v-card>
		</v-container>
	</div>
</template>

<script>
import rulesMixin from "@/mixins/rules-mixin";
import client from "@/client";
import clientNotifier from "@/clientNotifier";

export default {
	mixins: [rulesMixin, require("@/mixins/router-mixin").default],
	data() {
		return {
			breadcrumbs: [
				{
					text: "لوحة التحكم",
					disabled: false,
					to: { name: "dashboard-home" }
				},
				{ 
					text: "بيانات الاتصال",
					disabled: true 
				}
			],
			loading: true,
			info: [],

			headers: [
				{ value: "name", text: "نوع الإتصال" },
				{ value: "value", text: "المعرف" },
				{ value: "note", text: "ملاحظة" },
				{ value: "actions", text: "عمليات", align: "end" }
			],
			contactTypes: [],
			newCommunication: {
				value: null,
				type: null,
				note: ""
			},
		};
	},
	watch: {
		"newCommunication.type"(newVal) {
			if (newVal) {
				var type = this.contactTypes.find(
					com => com.communicationTypeID == this.newCommunication.type
				);
				if (type.initialProfilesPath == null) {
					type.initialProfilesPath = "";
				}
				this.newCommunication.value = "" + type.initialProfilesPath;
			}
		},
	},
	mounted() {
		this.getInfo();
		this.getContactTypes();
	},
	methods: {
		getInfo() {
			client
				.get("/api/system/allcontacts")
				.then(response => {
					this.info = response.data.data.map(communication => {
						communication.isEdit = false;
						communication.isLoading = false;
						return communication
					})
				})
				.finally(() => {
					this.loading = false;
				});
		},
		getContactTypes() {
			client
				.get("/api/communication/types")
				.then(response => {
					this.contactTypes = response.data;
					console.log(response);
				})
				.catch(err => {
					console.log(err);
				});
		},
		addContact() {
			this.loading = true;
			var data = new FormData();
			data.append("communicationTypeID", this.newCommunication.type);
			if (
				this.newCommunication.type == "telephone" &&
				this.newCommunication.extension
			) {
				var value =
					this.newCommunication.value +
					" تحويلة " +
					this.newCommunication.extension;
				data.append("value", value);
			} else {
				data.append("value", this.newCommunication.value);
			}
			data.append("note", this.newCommunication.note);

			clientNotifier
				.post("/api/system/newContact", data)
				.then(response => {
					var type = this.contactTypes.find(
						com =>
							com.communicationTypeID ==
							this.newCommunication.type
					);
					if (
						this.newCommunication.type == "telephone" &&
						this.newCommunication.extension
					) {
						this.newCommunication.value =
							this.newCommunication.value +
							" تحويلة " +
							this.newCommunication.extension;
					}
					this.info.push({
						...this.newCommunication,
						name: type.name,
						id: response.data,
						isEdit: false
					});
					this.newCommunication = {
						value: null,
						type: null,
						note: ""
					};
					console.log(response);
				})
				.finally(() => {
					this.loading = false;
				});
		},
		updateInfo(item) {
			item.isLoading = true;

			clientNotifier
				.post("/api/system/updateContact", item)
				.then(() => {
					item.isEdit = false;
				})
				.finally(() => {
					item.isLoading = false;
				});
		},
		enableEditCommunication(item) {
			console.log(item)
			if(item.isEdit) {
				this.updateInfo(item)
			} else {
				item.isEdit = true;
			}
		},
		deleteCommunication(item) {
			item.isLoading = true;

			clientNotifier
				.delete("/api/system/deleteContact/" + item.id)
				.then(response => {
					if (response == undefined) throw new Error("delete does not use then/catch");
					const index = this.info.findIndex(otherItem => otherItem.id == item.id)
					this.info.splice(index, 1);
				})
				.finally(() => {
					item.isLoading = false;
				});
		},
	}
};
</script>